<template>
  <div class="w-100">
    <v-row v-if="gameType === 'info'" align="center" justify="center">
      <v-btn class="next infoBtn" v-if="scenarioType !== 'btob' && page.nextOption.type === 'BTN'" @click="$emit('next', 'step')">
        {{ page.nextOption.data || 'Suivant' }}
      </v-btn>
    </v-row>
    <v-row v-else-if="gameType === 'mcq'" align="center" justify="center">
      <v-btn-toggle class="listAnswers" v-if="gameStep.status != 1">
        <v-btn class="answer" v-for="answer in gameStep.step.answers" :key="answer.name" v-html="answer.name" @click="testAnswer(answer.order)" />
      </v-btn-toggle>
      <v-btn class="next" @click="$emit('next', 'step')" v-if="gameStep.status == 1 && scenarioType !== 'btob' && page.nextOption.type === 'BTN'">
        {{ page.nextOption.data }}
      </v-btn>
    </v-row>
    <v-row v-else-if="gameType === 'guess'" align="center" justify="center">
      <v-col xs12 v-if="[0,1].includes(gameStep.subStatus)" align="center" justify="center">
        <v-btn @click="$emit('refresh', 'subStep')"> {{[0].includes(gameStep.subStatus) ? 'Suite' : 'Indice suivant'}} </v-btn>
      </v-col>
      <v-col xs12 v-if="scenarioType !== 'btob' && [5, 3].includes(gameStep.subStatus)" align="center" justify="center">
        <v-btn @click="$emit('next', 'step')"> Suivant </v-btn>
      </v-col>
      <v-col xs12 v-if="[4,6].includes(gameStep.subStatus)" align="center" justify="center">
        <v-btn @click="goBackToAnswer()"> Retour </v-btn>
      </v-col>
      <v-col xs4 v-if="[2].includes(gameStep.subStatus)"></v-col>
      <v-col xs4 v-if="[2].includes(gameStep.subStatus)" align="center" justify="center">
        <v-text-field label="Saisissez votre réponse..." placeholder="Saisissez votre réponse..." hide-details
          v-model="freeAnswer" solo :append-icon="freeAnswer.length < 3 ? '' : 'mdi-send'" @click:append="validateAnswer()"/>
      </v-col>
      <v-col xs4 v-if="[2].includes(gameStep.subStatus)" align="center" justify="center">
        <v-btn v-if="gameStep.areExtraInfoAvailable" outlined text @click="$emit('refresh', 'info')">Besoin d'aide ?</v-btn>
      </v-col>
    </v-row>
    <v-row v-else-if="gameType === 'aop'" align="center" justify="center">
      <v-btn class="next" @click="validatedAop" v-if="!gameStep.tryValidateAop">Valider</v-btn>
      <v-btn class="next" @click="$emit('next', 'step')" v-if="gameStep.tryValidateAop && scenarioType !== 'btob'">Suivant</v-btn>
    </v-row>
    <v-row v-else-if="gameType === 'm_mcq'" align="center" justify="center">
      <v-btn-toggle class="listAnswers">
        <v-btn class="answer" v-for="(r, i) in gameStep.question.r" :key="i" @click="testAnswerMMCQ(i)">{{letters[i]}}</v-btn>
      </v-btn-toggle>
      <v-btn class="next" @click="$emit('next', 'step')" v-if="gameStep.status == 1 && scenarioType !== 'btob'">Suivant</v-btn>
    </v-row>
    <v-btn v-else-if="gameType === 'start'" class="next" @click="start"> Go ! </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'GameActionBar',
    props: {
      page: {
        type: Object,
        default: () => {
          return {}
        },
      },
      gameStep: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    computed: {
      gameType: function () {
        return this.gameStep.type
      },
      scenarioType: function () {
        return SAPIO.Scenario.instance.type
      }
    },
    data: () => ({
      freeAnswer: '',
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O']
    }),
    methods: {
      testAnswer(answerId) {
        this.gameStep.testAnswer(answerId-1)
        this.$emit('refresh', 'answer')
      },
      testAnswerMMCQ(answerId) {
        this.gameStep.addAnswer(answerId)
        if (this.gameStep.questionIndex < this.gameStep.questions.length) this.$emit('refresh')
        else this.$emit('next', 'step')
      },
      goBackToAnswer() {
        this.gameStep.subStatus = 2
        this.$emit('refresh', 'subStep')
      },
      validateAnswer() {
        this.gameStep.testFreeAnswer(this.freeAnswer)
        this.$emit('refresh', 'answer')
      },
      validatedAop() {
        this.gameStep.testAnswer(this.$parent.aop.places)
        SAPIO.Game.instance.LS_SAVE()
        this.$emit('refresh', 'aop')
      }
    },
  }
</script>

<style scoped>
  .listAnswers {
    background-color: unset !important;
    width: 100%;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  
  .v-btn-toggle > .v-btn.v-btn {
    font-size: 2vh;
    height: 6vh;
    border-radius: 10px;
    padding: 0 1vh;
  }

  .v-btn-toggle > .v-btn.v-btn:first-child {
    border-radius: 10px;
  }

  .v-btn-toggle > .v-btn.v-btn:last-child {
    border-radius: 10px;
  }

  .infoBtn {
    text-align: center;
  }
</style>
